import { render, staticRenderFns } from "./RiskLevel.vue?vue&type=template&id=04e2d664"
import script from "./RiskLevel.vue?vue&type=script&lang=js"
export * from "./RiskLevel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports